import React, { useState, useEffect } from 'react';
import { Chip } from '@rmwc/chip';
import '@rmwc/chip/styles';
import KoordSystem from '../assets/KoordSystem.png';
import Quadrat from '../assets/Quadrat.png';
import QuadratFill from '../assets/QuadratFilled.png';
import Hochkant from '../assets/Hochkant.png';
import Längs from '../assets/Längs.png';
import Rohr from '../assets/Rohr.png';
import './ProfileViewer.css';
import { useFlexionStore } from '../Stores';
import { getText } from '../Helpers';

function ProfileViewer() {
  const SelectedProfile = useFlexionStore((state) => state.SelectedProfile);
  const Sprache = useFlexionStore((state) => state.Sprache);
  const [text, settext] = useState(getText(Sprache));

  function imgPrev() {
    if (SelectedProfile.Picture && SelectedProfile.Description !== undefined) {
      const replacedDotwithSlash = SelectedProfile.Description.replace(/\//, '-');
      const path = `Quer/${replacedDotwithSlash}.png`;
      return <img className='Querschnitt' src={path} alt='Querschnitt' />;
    }

    if (SelectedProfile.Querschnitt === 1) {
      return <img className='Placeholder' src={Quadrat} alt='Logo' />;
    }
    if (SelectedProfile.Querschnitt === 2) {
      if (SelectedProfile.X > SelectedProfile.Y) {
        return <img className='Placeholder' src={Längs} alt='Logo' />;
      }
      return <img className='Placeholder' src={Hochkant} alt='Logo' />;
    }
    if (SelectedProfile.Querschnitt === 3) {
      return <img className='Placeholder' src={Rohr} alt='Logo' />;
    }
    if (SelectedProfile.Querschnitt === 4) {
      return <img className='Placeholder' src={QuadratFill} alt='Logo' />;
    }
    return <img className='Placeholder' src={Hochkant} alt='Logo' />;
  }

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  return (
    <div className='viewer-container'>
      <img src={KoordSystem} alt='Logo' />
      <div className='QuerCont'>
        {imgPrev()}
        <div className='ChipX'>
          <Chip label={SelectedProfile.X?.toString()} />
        </div>
        <div className='ChipY'>
          <Chip label={SelectedProfile.Y?.toString()} />
        </div>
      </div>
      <p className='ViewerInfo'>{text.ProfileViewer.IxIy}</p>
    </div>
  );
}

export default ProfileViewer;
